import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ProductIdentifiers = (props: {
  productId: string | undefined, 
  morrisonsId: string | undefined, 
  barcode: string | undefined, 
  legacyCode: string | undefined
}) => {
  const { t } = useTranslation('productDetails');
  const theme = useTheme();

  return (
    <TableContainer sx={{ borderRadius: '12px' }}
      component='div'>
      <Table size="small">
        <TableHead sx={{ backgroundColor: theme.palette.custom.gray[200] }}>
          <TableRow>
            <TableCell width={'50%'}>
              {t('name')}
            </TableCell>
            <TableCell>
              {t('value')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('identifiersTab.productId')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.productId}
              </Typography>
            </TableCell>
          </TableRow>
                  
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('identifiersTab.morrisonsId')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.morrisonsId}
              </Typography>
            </TableCell>
          </TableRow>
                  
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('identifiersTab.barcode')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.barcode}
              </Typography>
            </TableCell>
          </TableRow>
                  
          <TableRow>
            <TableCell>
              <Typography variant='textXS'>
                {t('identifiersTab.legacyCode')}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant='textXS'>
                {props.legacyCode}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProductIdentifiers;